import { z } from "zod";

/** Known insight kinds the UI maps; the wire `kind` field also accepts unknowns. */
export const INSIGHT_KINDS = [
  "RECALCULATION_READY",
  "RESEARCH_FOUND",
  "RESEARCH_NEEDS_REVIEW",
  "RESEARCH_RUNNING",
  "REVIEW_REQUIRED",
  "RULE_PUBLISHED",
  "SAVINGS_OPPORTUNITY",
] as const;

export type InsightKind = (typeof INSIGHT_KINDS)[number];

const insightSubjectSchema = z.object({
  kind: z.enum(["CALCULATION", "UPLOAD", "FISCAL_TASK"]),
  id: z.string().min(1),
  label: z.string().max(200).nullable().optional(),
});

export const insightSchema = z.object({
  id: z.string().min(1),
  kind: z.string().min(1),
  severity: z.enum(["INFO", "POSITIVE", "CAUTION", "CRITICAL"]).catch("INFO"),
  title: z.string().max(300).nullable().optional(),
  amount: z
    .string()
    .regex(/^-?\d+(\.\d{1,2})?$/)
    .nullable()
    .optional(),
  count: z.number().int().nonnegative().nullable().optional(),
  subject: insightSubjectSchema.nullable().optional(),
  createdAt: z.string().datetime(),
  readAt: z.string().datetime().nullable().optional(),
});

export const insightFeedSchema = z.object({
  schemaVersion: z.literal("1.0.0"),
  unreadCount: z.number().int().nonnegative(),
  items: z.array(insightSchema).max(100),
  nextCursor: z.string().nullable().optional(),
});

export type Insight = z.infer<typeof insightSchema>;
export type InsightFeed = z.infer<typeof insightFeedSchema>;
